import { Edit2, Save, SaveIcon, Trash2, UserPlus, X } from "lucide-react";
import { useEffect, useState } from "react";
import Navbar from "../components/navbar";
import { ErrorAlert, SuccessAlert } from "../components/alertBox";

export default function UserManagement() {
    const [users, setUsers] = useState({});

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const [formData, setFormData] = useState({
        name: '',
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        role: 'admin',

    });
    const [formErrors, setFormErrors] = useState({})



    const handleUsers = async () => {
        try {
            const response = await fetch('https://payvoucher.netgateerp.lk/api/auth/get-users')

            if (!response.ok) {
                console.log("Error in getting the user response:", response.status, response.statusText)
                ErrorAlert("Error in fetching the users")
                return
            }
            const data = await response.json()
            console.log("Users:", data.users)
            setUsers(data)

        } catch (e) {
            console.log("Error in retrieving users", e)
            ErrorAlert("Error in retrieving users")
            return
        }

    }
    useEffect(() => {
        handleUsers()
    }, [])

    const validateForm = () => {
        const errors = {};

        // Check if all fields are filled
        if (!formData.name.trim()) {
            errors.name = 'Name is required';
        }

        if (!formData.username.trim()) {
            errors.username = 'Username is required';
        }

        if (!formData.email.trim()) {
            errors.email = 'Email is required';
        }

        if (!editingUser) {
            // Password validation only for new users
            if (!formData.password) {
                errors.password = 'Password is required';
            } else if (formData.password.length < 6) {
                errors.password = 'Password must be at least 6 characters';
            }

            if (!formData.confirmPassword) {
                errors.confirmPassword = 'Please confirm your password';
            } else if (formData.password !== formData.confirmPassword) {
                errors.confirmPassword = 'Passwords do not match';
            }
        }

        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // const openAddModal = () => {
    //     setEditingUser(null);
    //     setFormData({ name: '', email: '', role: 'User' });
    //     setIsModalOpen(true);
    // };

    const openEditModal = (user) => {
        setEditingUser(user);
        console.log("User data in edit field:", user)
        setFormData({ id: user.id, name: user.name, email: user.email, role: user.role });
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setEditingUser(null);
        setFormData({ name: '', email: '', role: 'User' });
    };

    // const handleSubmit = async () => {
    //     console.log("Form data on submit:",formData)
    //     if (!validateForm()) {
    //         return;
    //     }
    //     try {
    //         const response = await fetch('https://payvoucher.netgateerp.lk/api/auth/add-users', {
    //             method: "POST",
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify(formData)
    //         })
    //         if (!response.ok) {
    //             console.log("Error getting the submit response:", response.status, response.statusText)
    //             return
    //         }
    //         console.log("User added successfully")
    //         SuccessAlert("User added successfully")
    //         closeModal();
    //         handleUsers()
    //     } catch (e) {
    //         console.log("Error in submitting the form", e)
    //         ErrorAlert("Error in submitting the form")
    //         return
    //     }


    // };

    const handleDelete = async (id) => {
        const response = await fetch(`https://payvoucher.netgateerp.lk/api/auth/delete-user/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        if (!response.ok) {
            console.log("Error in deleting the response:", response.status, response.statusText)
            ErrorAlert("Error in deleting the response")
            return
        }
        console.log("Successfully deleted the user")
        SuccessAlert("Successfully deleted the user")
        handleUsers()
    };

    const handleUpdate = async (id) => {
        try {
            console.log("Updated data:", formData)
            const response = await fetch(`https://payvoucher.netgateerp.lk/api/auth/update-user/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)

            })
            if (!response.ok) {
                console.log("Error in getting the response:", response.status, response.statusText)
                ErrorAlert('Error in getting the response')
                return
            }
            setIsModalOpen(false)
            const userStr = localStorage.getItem('user')
            const userData = JSON.parse(userStr)
            userData.role = formData.role
            console.log("User role after update:", formData.role)
            localStorage.setItem('user', JSON.stringify(userData))
            SuccessAlert("User updated successfully")
            handleUsers()

        } catch (e) {
            ErrorAlert("Error in updating the user")
            console.log("Error in updating the user")
            return
        }
    }
    return (
        <>
            <Navbar />
            <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 p-8">
                <div className="max-w-7xl mx-auto">
                    <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                        {/* Header */}
                        <div className="bg-[#1B2F69] px-8 py-6">
                            <div className="flex justify-between items-center">
                                <div>
                                    <h1 className="text-3xl font-bold text-white">User Management</h1>
                                    <p className="text-blue-100 mt-1">Manage your team members and their roles</p>
                                </div>
                                {/* <button
                                    onClick={openAddModal}
                                    className="flex items-center gap-2 bg-white text-[#2EA9DB] px-6 py-3 rounded-lg font-semibold hover:bg-blue-50 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                                >
                                    <UserPlus size={20} />
                                    Add User
                                </button> */}
                            </div>
                        </div>

                        {/* Table */}
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-slate-50 border-b border-slate-200">
                                    <tr>
                                        <th className="px-8 py-4 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Name</th>

                                        <th className="px-8 py-4 text-left text-xs font-semibold text-slate-600 uppercase tracking-wider">Role</th>
                                        <th className="px-8 py-4 text-right text-xs font-semibold text-slate-600 uppercase tracking-wider">Actions</th>

                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-slate-200">
                                    {users.users?.map((user) => (
                                        <tr key={user.id} className="hover:bg-slate-50 transition-colors duration-150">
                                            <td className="px-8 py-5">
                                                <div className="flex items-center">
                                                    <div className="h-10 w-10 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center text-white font-semibold text-sm">
                                                        {user.name.split(' ').map(n => n[0]).join('')}
                                                    </div>
                                                    <span className="ml-3 font-medium text-slate-900">{user.name}</span>
                                                </div>
                                            </td>

                                            <td className="px-8 py-5">
                                                <span className={'inline-flex px-3 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-700'
                                                }>
                                                    {user.displayRole}
                                                </span>
                                            </td>

                                            <td className="px-8 py-5">
                                                <div className="flex justify-end gap-2">
                                                    <button
                                                        onClick={() => openEditModal(user)}
                                                        className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-200"
                                                        title="Edit user"
                                                    >
                                                        <Edit2 size={18} />
                                                    </button>
                                                    <button
                                                        onClick={() => handleDelete(user.id)}
                                                        className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200"
                                                        title="Delete user"
                                                    >
                                                        <Trash2 size={18} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {users.length === 0 && (
                            <div className="text-center py-12">
                                <p className="text-slate-500 text-lg">No users found. Add your first user to get started!</p>
                            </div>
                        )}
                    </div>
                </div>

                {/* Modal */}
                {/* Modal – Improved UX version */}
                {isModalOpen && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md transform transition-all animate-in fade-in zoom-in duration-200">
                            {/* Header */}
                            <div className="flex justify-between items-center px-6 py-4 border-b border-slate-200">
                                <h2 className="text-2xl font-bold text-slate-900">
                                    {editingUser ? 'Edit User' : 'Add New User'}
                                </h2>
                                <button
                                    onClick={closeModal}
                                    className="text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full p-2 transition-all"
                                    aria-label="Close modal"
                                >
                                    <X size={24} />
                                </button>
                            </div>

                            {/* Body */}
                            <div className="p-6 space-y-5 max-h-[75vh] overflow-y-auto">
                                {/* Name */}
                                <div>
                                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                                        Full Name <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={(e) => handleInputChange(e)}
                                        placeholder="John Doe"
                                        className={`w-full px-4 py-3 border ${formErrors.name ? 'border-red-500 focus:ring-red-300' : 'border-slate-300 focus:ring-blue-500'} rounded-lg focus:border-transparent outline-none transition-all`}
                                    />
                                    {formErrors.name && <p className="text-red-500 text-xs mt-1 flex items-center gap-1"><span>⚠</span>{formErrors.name}</p>}
                                </div>

                                {/* Username */}
                                {!editingUser && (
                                    <div>
                                        <label className="block text-sm font-semibold text-slate-700 mb-2">
                                            Username <span className="text-red-500">*</span>
                                        </label>
                                        <input
                                            type="text"
                                            name="username"
                                            value={formData.username}
                                            onChange={(e) => handleInputChange(e)}
                                            placeholder="superAdmin"
                                            className={`w-full px-4 py-3 border ${formErrors.username ? 'border-red-500 focus:ring-red-300' : 'border-slate-300 focus:ring-blue-500'} rounded-lg focus:border-transparent outline-none transition-all`}
                                        />
                                        {formErrors.username && <p className="text-red-500 text-xs mt-1 flex items-center gap-1"><span>⚠</span>{formErrors.username}</p>}
                                    </div>
                                )}


                                {/* Password fields – only when adding new user */}
                                {!editingUser && (
                                    <>
                                        <div>
                                            <label className="block text-sm font-semibold text-slate-700 mb-2">
                                                Password <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="password"
                                                name="password"
                                                value={formData.password}
                                                onChange={(e) => handleInputChange(e)}
                                                placeholder="••••••••"
                                                className={`w-full px-4 py-3 border ${formErrors.password ? 'border-red-500 focus:ring-red-300' : 'border-slate-300 focus:ring-blue-500'} rounded-lg focus:border-transparent outline-none transition-all`}
                                            />
                                            {formErrors.password && <p className="text-red-500 text-xs mt-1 flex items-center gap-1"><span>⚠</span>{formErrors.password}</p>}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-semibold text-slate-700 mb-2">
                                                Confirm Password <span className="text-red-500">*</span>
                                            </label>
                                            <input
                                                type="password"
                                                name="confirmPassword"
                                                value={formData.confirmPassword}
                                                onChange={(e) => handleInputChange(e)}
                                                placeholder="••••••••"
                                                className={`w-full px-4 py-3 border ${formErrors.confirmPassword ? 'border-red-500 focus:ring-red-300' : 'border-slate-300 focus:ring-blue-500'} rounded-lg focus:border-transparent outline-none transition-all`}
                                            />
                                            {formErrors.confirmPassword && <p className="text-red-500 text-xs mt-1 flex items-center gap-1"><span>⚠</span>{formErrors.confirmPassword}</p>}
                                        </div>
                                    </>
                                )}

                                {/* Role */}
                                {!editingUser ? (
                                    <div>
                                        <label className="block text-sm font-semibold text-slate-700 mb-2">Role</label>
                                        <select
                                            name="role"
                                            value={formData.role}
                                            onChange={(e) => handleInputChange(e)}
                                            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                                        >

                                            <option value="admin">Admin</option>
                                            <option value="superadmin">Super Admin</option>
                                        </select>
                                    </div>
                                ) : (
                                    <div>
                                        <label className="block text-sm font-semibold text-slate-700 mb-2">Role</label>
                                        <select
                                            name="role"
                                            value={formData.role}
                                            onChange={(e) => handleInputChange(e)}
                                            className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                                        >

                                            <option value="admin">Admin</option>
                                            <option value="superadmin">Super Admin</option>
                                        </select>
                                    </div>
                                )}



                            </div>

                            {/* Footer */}
                            <div className="flex gap-3 px-6 py-5 bg-slate-50 border-t border-slate-200">
                                <button
                                    onClick={closeModal}
                                    className="flex-1 px-6 py-3 border border-slate-300 text-slate-700 rounded-lg font-semibold hover:bg-slate-100 transition-all"
                                >
                                    Cancel
                                </button>
                                {editingUser ? (
                                    <button
                                        onClick={() => { handleUpdate(editingUser.id) }}
                                        className="flex-1 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-all flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
                                    >
                                        <SaveIcon size={18} />
                                        {editingUser ? 'Update User' : 'Create User'}
                                    </button>
                                ) : (
                                    <button
                                        // onClick={handleSubmit}
                                        className="flex-1 px-6 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-all flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
                                    >
                                        <Save size={18} />
                                        {editingUser ? 'Update User' : 'Create User'}
                                    </button>
                                )}

                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}